import { DEVURL, PPURL, SIT2URL, SITURL } from '../Constants';
import HookLoader from './HookLoader/HookLoader';
import useFetch from './useFetch';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;


interface Props {
    setEnv: (flag: boolean) => void;
}

const ResourceEnvironment = ({ setEnv }: Props) => {
    let utilUrl = baseUrl;

    if (baseUrl.includes('apisit')) {
        utilUrl = SITURL;
    } else if (baseUrl.includes('apipreprod')) {
        utilUrl = PPURL;
    } else if (baseUrl.includes('apidev')) {
        utilUrl = DEVURL;
    } else if (baseUrl.includes('apisit2')) {
        utilUrl = SIT2URL;
    }

    const url = `${utilUrl}/mobilyTheme4/BzFvwmzXvs`;
    const req = { "data": "APIGEE_BM_BASE_URL~CEM_KEY~APIGEE_BM_ X_API_KEY~APIGEE_BASE_URL~BM_PUBLIC_KEY~ENVIRONMENT~CEM_KEYCLOAK_PUBLIC_KEY~BM_CLIENT_ID~MIXPANEL_TOKEN~MIXPANEL_ENABLED~TRADE_IN_ENABLED~DEVICE_OFFLINE" };
    const { response, loading }: any = useFetch(url, req, setEnv);


    if (response) {
        const env = response?.ENVIRONMENT;
        let bmcs = import.meta.env.VITE_PD_BM_CS;

        if (env === 'SIT') {
            bmcs = import.meta.env.VITE_SI_BM_CS;
        } else if (env === 'PREPROD') {
            bmcs = import.meta.env.VITE_PP_BM_CS;
        } else if (env === 'DEV') {
            bmcs = import.meta.env.VITE_DE_BM_CS;
        } else if (env === 'SIT2') {
            bmcs = import.meta.env.VITE_SI2_BM_CS
        }
        !!!win["cem_key"] && (win["cem_key"] = response.CEM_KEY);
        !!!win["apigee_base_api_url"] && (win["apigee_base_api_url"] = response.APIGEE_BASE_URL);
        !!!win["apigee_bm_base_url"] && (win["apigee_bm_base_url"] = response.APIGEE_BM_BASE_URL);
        !!!win["apigee_bm_x_api_key"] && (win["apigee_bm_x_api_key"] = response['APIGEE_BM_ X_API_KEY']);
        !!!win["public_key"] && (win["public_key"] = response.BM_PUBLIC_KEY);
        !!!win["cem_public_key"] && (win["cem_public_key"] = response.CEM_KEYCLOAK_PUBLIC_KEY);
        !!!win["BM_CI"] && (win["BM_CI"] = response.BM_CLIENT_ID);
        !!!win["BM_CS"] && (win["BM_CS"] = bmcs);
        !!!win["env_variable"] && (win["env_variable"] = env);
        !!!win["errorPageURL"] && (win["errorPageURL"] = '/wps/portal/web/personal/store/error');
         win['AllowedAPIRetryCount'] = 4;
         !!!win["mixpanel_url"] && (win["mixpanel_url"] = `${baseUrl}/MobilyTheme4Resources/js/mixpanel-tracker.js`);
        !!!win["mixpanel_token"] && (win["mixpanel_token"] = response.MIXPANEL_TOKEN);
        !!!win["mixpanel_enabled"] && (win["mixpanel_enabled"] = response.MIXPANEL_ENABLED);
        !!!win["trade_in_enabled"] && (win["trade_in_enabled"] = response.TRADE_IN_ENABLED);
        !!!win["device_offline"] && (win["device_offline"] = response.DEVICE_OFFLINE);
    }

    return (
        <>
            {loading && <HookLoader loading={loading} />}
        </>
    )
}

export default ResourceEnvironment